import React from "react";
import styled from "styled-components";
import { Spacing } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import { Chip, Description } from "@ui-kit/form";
import Line from "@radarly/components/panels/card-edition/sidebar/line";
import { tr } from "@radarly/i18n";
import { HiddenTermCard } from "@radarly/models/cards/model";

export interface IProps {
  card: HiddenTermCard;
  onDeleteTerm: (term: string) => void;
  locale: Locale;
}

const Terms = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${Spacing.Small};
`;

export default function HiddenTerms({ card, onDeleteTerm, locale }: IProps) {
  return (
    <Line title={tr(locale, "INSIGHT_PAGE::EDITOR::HIDDENT_TERM_LABEL")}>
      <Description>
        {tr(locale, "INSIGHT_PAGE::EDITOR::HIDDENT_TERM_TEXT")}
      </Description>
      <Terms>
        {card.dataviz.hiddenTerms &&
          card.dataviz.hiddenTerms.map((hiddenTerm) => (
            <Chip
              key={hiddenTerm}
              label={hiddenTerm}
              status="selected"
              onClickClose={() => onDeleteTerm(hiddenTerm)}
            />
          ))}
      </Terms>
    </Line>
  );
}
